// Zotte Zomer Ronse 2026 — Partner placeholders (seed data, fictief)
// FICTIEVE namen — bewust niet refererend aan bestaande Ronsese bedrijven.
// Wordt in fase 2 vervangen via admin/CMS. NIET KOPIEREN naar productie zonder vervangen.
// CRITICAL: NO PRICES, NO AMOUNTS — alleen logo/naam + formule.

export const PARTNERS = [
    // ===== ZOMERKICK (premium, max 3) =====
    { id: 'p-kick-1', name: "Brouwerij 't Kasseiveld", formula: 'zomerkick', website: '#', placeholder: true },
    { id: 'p-kick-2', name: 'Bouwgroep Vandermeersch', formula: 'zomerkick', website: '#', placeholder: true },

    // ===== ZOMERBOOST =====
    { id: 'p-boost-1', name: 'Garage Vandenhoudt', formula: 'zomerboost', website: '#', placeholder: true },
    { id: 'p-boost-2', name: 'Notariaat De Coninck & Partners', formula: 'zomerboost', website: '#', placeholder: true },
    { id: 'p-boost-3', name: "Bakkerij De Smet", formula: 'zomerboost', website: '#', placeholder: true },

    // ===== ZOMERVIBES =====
    { id: 'p-vibes-1', name: 'Optiek Vanhove', formula: 'zomervibes', website: '#', placeholder: true },
    { id: 'p-vibes-2', name: "Brasserie 't Marktje", formula: 'zomervibes', website: '#', placeholder: true },
    { id: 'p-vibes-3', name: 'Apotheek Verbeke', formula: 'zomervibes', website: '#', placeholder: true },

    // ===== ZOMERGOESTING =====
    { id: 'p-goest-1', name: 'Slagerij Dhondt', formula: 'zomergoesting', website: '#', placeholder: true },
    { id: 'p-goest-2', name: 'Bloemen Lieselot', formula: 'zomergoesting', website: '#', placeholder: true },
    { id: 'p-goest-3', name: 'IT-Werk Pelster', formula: 'zomergoesting', website: '#', placeholder: true },
    { id: 'p-goest-4', name: "Tuinhuis 't Vlaspand", formula: 'zomergoesting', website: '#', placeholder: true },
];
